import { Inject, Injectable, LOCALE_ID } from '@angular/core'
import { Locale } from 'date-fns'
import { de, enUS, es, fr, it, pt } from 'date-fns/locale'

@Injectable({
  providedIn: 'root',
})
export class LocalizationDateFnsService {
  private readonly dateFnsLocales: { [key: string]: Locale } = {
    en: enUS,
    'en-US': enUS,
    it: it,
    'it-IT': it,
    es: es,
    fr: fr,
    de: de,
    pt: pt,
  }

  constructor(@Inject(LOCALE_ID) private readonly localeId: string) {}

  /**
   * Returns the current date-fns locale with fallback to base language or default.
   * @returns The resolved date-fns Locale.
   */
  getCurrentLocale(): Locale {
    const baseLocale = this.localeId.split('-')[0]
    return this.dateFnsLocales[this.localeId] || this.dateFnsLocales[baseLocale] || it
  }
}
